
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sorular/[courseSlug]",
      function () {
        return require("private-next-pages/sorular/[courseSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sorular/[courseSlug]"])
      });
    }
  